<template>

  <div class="actImg" :style="info.css" @click.prevent="appointment">
    <img :src="image" class="img">
    <div v-if="loading" class="loading">
      <div class="fall"></div>
      <van-loading type="spinner" color="white"/>
    </div>
  </div>
</template>


<script>

  import click_handler from '../../tools/mgtv/click'
  import handler_action from '../../tools/mgtv/action'
  import {getJSON, postJSON} from '../../api/myaxios'
  import {Loading} from 'vant';
  import Vue from 'vue';
  import {USRE_INFO_LOAD} from '../../constant/eventbus'
  import {isArray} from '../../tools/typeof'

  Vue.use(Loading);


  export default {
    name: 'Appointment',
    props: ['info'],
    components: {Loading},
    data() {
      return {
        loading: false,
        yuyue: false
      }
    },
    methods: {
      appointment() {
        if (this.yuyue) {
          return;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        setTimeout(() => {
          this.loading = false
        }, 333);
        click_handler(this.info.name, () => {
          this._appointment();
        }, {
          need_login: true,
          need_act: true,
          need_new_user: this.info.need_new_user,
          need_vip_level: this.info.need_vip_level,
        })
      },
      _appointment() {
        const ticket = window.$bus.user.ticket;
        if (!ticket) {
          return;
        }
        const fields = this.info.appoint_fields;
        if (!fields || fields.length === 0) {
          this._appointment_api();
          return;
        }

        window.$submit_dialog.show({
          submitDialog: {
            title: '请填写以下信息',
            submit: '确定',
            fields: fields
          },
          submitAction: this._appointment_api
        });
      },
      _appointment_api(submit_info = [{}]) {
        const param = {
          ticket: window.$bus.user.ticket,
          act_name: window.rootdata.act_name,
          phase: 'YY_' + this.info.name //约定 预约项YY_开头
        };
        //这个接口后端做的比较奇怪，如果没有提交信息，post中的info字段不能为空，只能 [{}]这么写了。
        return postJSON(`//vipact3.api.mgtv.com/api/v1/act/uinfo/add`, param, {'info': submit_info})
          .then(res => {
            if (!res) {
              window.$toast('请求超时');
              return 'fail';
            }
            if (res.ret === 0) {
              this.yuyue = true;
              if (this.info.appoint_succ) {
                window.$toast(this.info.appoint_succ);
              }
              return 'success' //为了兼容$submit_dialog
            } else {
              // window.$toast("预约失败");
              return 'fail'
            }
          })
      },
      queryAppointmentStatus() {
        if (window.$bus.user.ticket) {
          this._queryAppointmentStatus()
        } else {
          window.$bus.$on(USRE_INFO_LOAD, () => {
            this._queryAppointmentStatus()
          })
        }
      },
      _queryAppointmentStatus() {
        const ticket = window.$bus.user.ticket;
        if (!ticket) {
          return;
        }
        const params = {
          ticket,
          act_name: window.rootdata.act_name,
          phase: 'YY_' + this.info.name, //约定 预约项YY_开头
          t:new Date().getTime()
        }
        getJSON(`//vipact3.api.mgtv.com/api/v1/act/uinfo/get`, params)
          .then(res => {
            if (!res) {
              return;
            }
            if (res.ret === 0) {
              if (res.data.id) {
                this.yuyue = true;
              }
            }
          })
      }
    },
    computed: {
      image() {
        return this.yuyue ? this.info.appoint_img2 : this.info.appoint_img1;
      },
      ticket() {
        return window.$bus.user.ticket
      }
    }
    ,
    created() {
      this.queryAppointmentStatus()
    }
    ,
    mounted() {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .actImg
    overflow hidden
    .img
      display block
      width 100%
      height 100%

  .actImgHolder
    border 1px dashed red
    color red
    display flex
    justify-content center
    align-items center

  .loading
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    display flex
    justify-content center
    align-items center

  .fall
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    background-color: rgba(0, 0, 0, .3);

</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/Appointment.vue